module.exports = __webpack_public_path__ + "img/timer.8c58a80b.svg";